import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Tab } from "@similarweb/ui-components";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledStaticListContainer = styled(FlexColumn)``;

export const StyledStaticListItemsContainer = styled(FlexColumn)``;

export const StyledCustomIcon = styled(SWReactIcons)<{ iconSize?: number; rightSpace?: number }>`
    display: flex;
    align-items: center;
    margin-right: ${({ rightSpace }) => rightSpace || 16}px;
    svg {
        width: ${({ iconSize }) => iconSize || 32}px;
        height: ${({ iconSize }) => iconSize || 32}px;
    }
`;

export const StyledListHistoryPagination = styled.div`
    display: flex;
    justify-content: end;
    border-top: 1px solid ${colorsPalettes.carbon[100]};
    background: ${colorsPalettes.carbon[0]};
`;

export const StyledListTab = styled(Tab)`
    display: flex;
    min-height: 47px;
    color: ${colorsPalettes.carbon["300"]};
    font-family: "DM Sans", sans-serif !important;
    font-weight: 700 !important;
`;
